import { makeStyles } from "@material-ui/core/styles";

const drawerWidth = 100;
const headerHeightDesktop = 90;
const headerHeightMobile = 80;

export const useSideBarStyles = makeStyles(theme => ({
  sidebar: {
    width: drawerWidth,
    backgroundColor: "#121212",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px 0",
    height: `calc(100vh - ${headerHeightDesktop}px)`,
    borderRight: "1px solid #363636",
    position: "sticky",
    top: headerHeightDesktop,
    zIndex: 1,
    overflowY: "auto",
    overflowX: "hidden",
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#363636",
      borderRadius: "3px",
      "&:hover": {
        background: "#4a4a4a",
      },
    },
    [theme.breakpoints.down("sm")]: {
      position: "relative",
      top: 0,
      width: "100%",
      height: `calc(100vh - ${headerHeightMobile}px)`,
      padding: "32px 0",
      overflowY: "visible",
    },
  },
  sidebarIconsTop: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
  sidebarIconsBottom: {
    marginTop: "auto",
    marginBottom: theme.spacing(12),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  sidebarIcon: {
    color: "#ffffff",
    opacity: 0.7,
    transition: "all 0.2s ease",
    "& svg": {
      width: 24,
      height: 24,
    },
    "&:hover": {
      color: "#f06ec4",
      opacity: 1,
      backgroundColor: "rgba(240, 110, 196, 0.08)",
    },
  },
  sidebarIconActive: {
    color: "#FE5A97",
    opacity: 1,
    backgroundColor: "rgba(254, 90, 151, 0.15)",
    border: "1px solid #EF599680",
    transition: "all 0.2s ease",
    "& svg": {
      width: 24,
      height: 24,
    },
    "&:hover": {
      color: "#FE5A97",
      opacity: 1,
    },
  },

  burgerButton: {
    position: "fixed",
    top: theme.spacing(1),
    left: theme.spacing(1),
    zIndex: theme.zIndex.drawer + 1,
    color: "#ffffff",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
    [theme.breakpoints.down("sm")]: {
      top: "13px",
    },
  },
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: "#121212",
    top: headerHeightDesktop,
    height: `calc(100vh - ${headerHeightDesktop}px)`,
    [theme.breakpoints.down("sm")]: {
      width: "100vw",
      top: headerHeightMobile,
      height: `calc(100vh - ${headerHeightMobile}px)`,
      borderRight: "none",
    },
  },
  mobileMenuContainer: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    backgroundColor: "#121212",
    color: "#ffffff",
    overflow: "hidden",
  },
  mobileMenuScrollable: {
    flex: 1,
    overflowY: "auto",
    overflowX: "hidden",
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#363636",
      borderRadius: "3px",
      "&:hover": {
        background: "#4a4a4a",
      },
    },
  },
  mobileMenuList: {
    width: "100%",
    padding: theme.spacing(3, 3, 1, 3),
  },
  mobileMenuItem: {
    borderRadius: 12,
    marginBottom: theme.spacing(1),
    padding: theme.spacing(1.5, 2),
    color: "#ffffff",
    minHeight: 48,
    "&:hover": {
      color: "#ffffff",
      backgroundColor: "rgba(254, 90, 151, 0.08)",
    },
    "&:focus": {
      color: "#ffffff",
      outline: "none !important",
    },
    "&:active": {
      color: "#ffffff",
      outline: "none !important",
      boxShadow: "none !important",
    },
    "&.Mui-focusVisible": {
      outline: "none !important",
      boxShadow: "none !important",
    },
    "&.MuiButtonBase-root": {
      "&:focus": {
        outline: "none !important",
      },
      "&:active": {
        outline: "none !important",
      },
      "&.Mui-focusVisible": {
        outline: "none !important",
      },
    },
    "&.MuiListItem-root": {
      "&:focus": {
        outline: "none !important",
      },
      "&:active": {
        outline: "none !important",
      },
      "&.Mui-focusVisible": {
        outline: "none !important",
      },
    },
  },
  mobileMenuItemActive: {
    color: "#ffffff",
    backgroundColor: "rgba(254, 90, 151, 0.15)",
    border: "1px solid rgba(254, 90, 151, 0.3)",
  },
  mobileMenuText: {
    fontFamily: "'TT Norms', sans-serif",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: 1.5,
  },
  mobileListIcon: {
    color: "#ffffff",
    minWidth: 40,
    marginRight: 0,
    "& svg": {
      width: 24,
      height: 24,
    },
  },
  mobileMenuDivider: {
    margin: theme.spacing(2, 0),
    backgroundColor: "rgba(255, 255, 255, 0.1)",
  },
  mobileBottom: {
    marginTop: "auto",
    padding: theme.spacing(0, 3, 3, 3),
    backgroundColor: "#121212",
    flexShrink: 0,
  },
}));
